import { Z_INDEX_COPILOT_SIDEBAR } from '../../../constants/z_index';
const COPILOT_SIDEBAR_WIDTH = '384'; // 400 - left / right margin of 8px
const COPILOT_SIDEBAR_ON_LEFT_WIDTH = '368'; // 400 - left / right margin of 16px

export const getStyle = (isLeftSidebar = false) => {
  const styles = {
    border: '1px solid transparent',
    background: '#ffffff',
    borderRadius: '16px',
    position: 'fixed',
    top: 'var(--global-nav-height, 44px)',
    // GLOBAL_NAVIGATION_TOOLBAR_DEFAULT_HEIGHT: https://git.hubteam.com/HubSpot/Navigation/blob/master/nav-meta/static/js/constants.ts#L7
    zIndex: Z_INDEX_COPILOT_SIDEBAR
  };
  if (isLeftSidebar) {
    return Object.assign({}, styles, {
      left: 'var(--global-nav-vertical-nav-width, 0px)',
      margin: '16px',
      width: `${COPILOT_SIDEBAR_ON_LEFT_WIDTH}px`,
      height: `calc(100vh - var(--global-nav-height, 44px) - 32px)`,
      // GLOBAL_NAVIGATION_TOOLBAR_DEFAULT_HEIGHT: https://git.hubteam.com/HubSpot/Navigation/blob/master/nav-meta/static/js/constants.ts#L7
      boxShadow: `0px 16px 32px 0px rgba(20,20,20,0.08),
        0px -28px 0px 16px rgba(240,240,240,1),
        0px 28px 0px 16px rgba(240,240,240,1)`
    });
  }
  return Object.assign({}, styles, {
    right: 0,
    margin: '8px 8px 8px 0',
    width: `${COPILOT_SIDEBAR_WIDTH}px`,
    height: `calc(100vh - var(--global-nav-height, 44px) - 20px)`,
    // GLOBAL_NAVIGATION_TOOLBAR_DEFAULT_HEIGHT: https://git.hubteam.com/HubSpot/Navigation/blob/master/nav-meta/static/js/constants.ts#L7
    boxShadow: `0px 16px 32px 0px rgba(20,20,20,0.08),
        0px -28px 0px 16px rgba(240,240,240,1),
        0px 28px 0px 16px rgba(240,240,240,1)`
  });
};